import React from 'react'

import Subtitle from '@/components/ui/Typo/Subtitle'

interface Props {
  text: string
  className?: string
}

const ErrorCard: React.FC<Props> = ({ text, className = '' }) => {
  return (
    <div className={`bg-red-500 px-10 py-2 rounded ${className}`}>
      <Subtitle
        color="text-white"
        className="small:text-left text-center"
        weight="font-medium"
        uppercase={false}
      >
        {text}
      </Subtitle>
    </div>
  )
}

export default ErrorCard
